(() => {
  const consented = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const send = (name, params = {}) => {
    if (window.Shopify?.theme?.role !== 'main' || window.Shopify?.designMode) return;
    if (!consented() || typeof window.gtag !== 'function') return;
    window.gtag('event', name, params);
  };
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin) return;
    const placement = link.closest('[data-diennet-cta]')?.dataset.diennetCta || 'other';
    if (url.pathname.endsWith('/pages/new-patient-questionnaire')) send('assessment_cta_click', { placement });
    else if (url.pathname.includes('/products/')) send('programme_link_click', { placement });
  });
  let started = false;
  document.addEventListener('focusin', event => {
    if (started || !location.pathname.endsWith('/pages/new-patient-questionnaire')) return;
    const field = event.composedPath().find(node => node?.tagName && /^(INPUT|TEXTAREA|SELECT)$/.test(node.tagName));
    if (!field || !event.composedPath().some(node => node?.hasAttribute?.('data-dn-questionnaire'))) return;
    if (!consented()) return;
    started = true;
    send('assessment_start');
  });
  if (location.pathname.endsWith('/pages/assessment-next-step')) send('assessment_next_step_view');
})();

